export const EVENT_STATS_FIND_SEND = 'EVENT_STATS_FIND_SEND';
export const EVENT_STATS_FIND_RECEIVED = 'EVENT_STATS_FIND_RECEIVED';
export const EVENT_STATS_FIND_ERROR = 'EVENT_STATS_FIND_ERROR';
